var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"msgtypeLocation"},[_c('div',{staticClass:"mymap",attrs:{"id":'mymap' + _vm.index}},[_c('p',[_vm._v(_vm._s(_vm.items.content.title))])])])}
var staticRenderFns = []

export { render, staticRenderFns }